module.exports = __webpack_public_path__ + "img/whatsapp-icn.a63c1973.png";